import { memo, type FC } from 'react';
import { useTheme } from 'styled-components';

import Icons from '../../../../Elements/Icons/index.ts';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.tsx';
import { TableCellInnerWrapper } from '../TableCell/styled.ts';
import { TableHeadWrapper } from './styled.ts';
import type { TableHeadProps } from './types.ts';

export const TableHead: FC<TableHeadProps> = memo(function TableHead({ children, className, dataTestId, $sticky, ...props }) {
  const { order, handleChangeOrder, tooltip } = props;
  const { colors } = useTheme();

  return (
    <TableHeadWrapper
      {...props}
      className={className}
      sortable={!!handleChangeOrder}
      onClick={handleChangeOrder}
      data-testid={dataTestId}
      $sticky={$sticky}>
      <TableCellInnerWrapper {...props} noWrap>
        {handleChangeOrder && (
          <Icons.Arrow size={16} color={order ? colors.main : colors.black_1} align={order === 'ASC' ? 'top' : 'bottom'} />
        )}
        {children}
        {tooltip && <InfoTooltipIcon tooltip={tooltip} />}
      </TableCellInnerWrapper>
    </TableHeadWrapper>
  );
});
